import { render } from "./TheHeader.vue?vue&type=template&id=6a5510b4&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=6a5510b4&scoped=true&lang=css"

import exportComponent from "D:\\Shehab\\Coding\\vue\\Maxmillian\\Vue-The-Complete-Guide\\lec 18\\deploy01-starting-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5510b4"]])

export default __exports__